import { routeNames } from "./data";

export const routeOptions = Object.entries(routeNames).map(([key, value]) => ({
  key,
  value,
}));

export const CONTACT_ROUTE_KEYS = ["Call", "Whatsapp"];
const legacyContactNumbers = new Set(["9306655624"]);

const parseLink = (link) => {
  if (!link || typeof link !== "string") return link;
  try {
    const parsed = JSON.parse(link);
    return parsed && typeof parsed === "object" ? parsed : link;
  } catch {
    return link;
  }
};

const normalizeRouteKey = (key) => {
  if (!key) return "";
  const match = routeOptions.find(
    (item) => item.key.toLowerCase() === String(key).trim().toLowerCase()
  );
  return match?.key || "";
};

export const isContactRoute = (key) => CONTACT_ROUTE_KEYS.includes(normalizeRouteKey(key));

export const getRouteLinkPayload = (key, contactNumber = "") => {
  const normalizedKey = normalizeRouteKey(key);
  if (!normalizedKey) return null;
  return {
    key: normalizedKey,
    value: isContactRoute(normalizedKey) ? String(contactNumber || "") : routeNames[normalizedKey],
  };
};

export const getRouteKeyFromLink = (link) => {
  link = parseLink(link);
  if (!link) return "";
  if (typeof link === "object") return normalizeRouteKey(link.key);
  if (legacyContactNumbers.has(String(link))) return "Call";
  const match = routeOptions.find((item) => item.value === link || item.key === link);
  return match?.key || "";
};

export const getRouteLinkLabel = (link) => {
  link = parseLink(link);
  if (!link) return "";
  if (typeof link === "object") {
    const key = normalizeRouteKey(link.key);
    if (isContactRoute(key) && link.value) return `${key} - ${link.value}`;
    return key || link.value || "";
  }
  const match = routeOptions.find((item) => item.value === link || item.key === link);
  return match?.key || link;
};

export const getRouteLinkValue = (link) => {
  link = parseLink(link);
  if (!link) return "";
  if (typeof link === "object") return link.value || "";
  const match = routeOptions.find((item) => item.value === link || item.key === link);
  return match?.value || link;
};
